import React from "react";
import { Drawer, DialogTitle, IconButton } from "@mui/material";
import SystemUserForm from "./SystemUserForm";
import { styles } from "utils/apis";
import { Cancel } from "@mui/icons-material";


const SystemUserDrawer = ({ mode, defaultData, open, handleClose }) => {

    return (
        <>
            <Drawer
                anchor={"bottom"}
                open={open}
                onClose={handleClose}
                sx={styles}     
            >
                <DialogTitle sx={{display: "flex", justifyContent: "flex-end", padding: 0}}>
                    <IconButton onClick={handleClose} sx={{color:"purple"}}>
                        <Cancel />
                    </IconButton>
                </DialogTitle>
                <SystemUserForm mode={mode} defaultData={defaultData} handleClose={handleClose} />
            </Drawer>
        </>
    )
}
export default SystemUserDrawer;